var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasFeatures
    ? _c(
        "div",
        { class: _vm.cardGroupClass },
        _vm._l(_vm.features, function (feature, index) {
          return _c("LayerFeatureableGroupItem", {
            key: `layer-featureable-feature-${index}`,
            attrs: {
              value: feature,
              title: _vm.entityName,
              featureableConfig: _vm.featureableConfig,
              translateID: _vm.translateID,
            },
            on: { selected: _vm.onSelected },
          })
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }